import { useState, useRef, useEffect, useContext } from 'react'
import {
  RelationshipsClient,
  TenantMgtSvcClient
} from '@jarvis/web-stratus-client'
import { ConfigContext } from '@/store'
import { ACCOUNT_TYPE_COMPANY } from '@/store/Constants'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Logger } from '@/utils/Logger'

const useTenancyRegistry = () => {
  const relationshipsClient = useRef(null)
  const tenantClient = useRef(null)
  const { authProvider, stack } = useContext(ConfigContext)
  const [isFetching, setIsFetching] = useState(false)
  const [availableOrganizations, setAvailableOrganizations] = useState(null)
  const {
    onbpReleaseTenantlesstokensupport: isTenantlessTokenSupported
  } = useFlags()

  const getOrganizations = (type = ACCOUNT_TYPE_COMPANY) => {
    setIsFetching(true)
    if (!relationshipsClient.current || !tenantClient.current) return
    let nodes = []

    return relationshipsClient.current
      .getAllPersonNodes({ filter: 'admin' })
      .then(async (response) => {
        for (const node of response.data.content) {
          await tenantClient.current.getTenantDetails(node).then((response) => {
            if (response.data.type === type) {
              nodes.push(response.data)
            }
          })
        }
        setAvailableOrganizations(nodes)
      })
      .catch((e) => {
        Logger.error('getOrganizations error:', e)
        setAvailableOrganizations([])
      })
      .finally(() => {
        setIsFetching(false)
      })
  }

  useEffect(() => {
    const resolvedAuthProvider = isTenantlessTokenSupported
      ? authProvider.createOrglessAuthProvider()
      : authProvider
    relationshipsClient.current = new RelationshipsClient(
      stack,
      resolvedAuthProvider
    )
    tenantClient.current = new TenantMgtSvcClient(stack, resolvedAuthProvider)
    return () => {
      relationshipsClient.current = null
      tenantClient.current = null
    }
  }, [authProvider, stack, isTenantlessTokenSupported])

  return {
    isFetching,
    availableOrganizations,
    getOrganizations
  }
}

export default useTenancyRegistry
